import { $authHost } from ".";
import { GetTicketsResponse } from "@/@types/tickets.types";

export async function getTickets() {
  const response = await $authHost.request<GetTicketsResponse>({
    url: "/tickets",
  });
  return response;
}

export async function getClosedTickets() {
  const response = await $authHost.request<GetTicketsResponse>({
    url: "/tickets",
    params: {
      status: "closed",
    },
  });
  return response;
}
